<template>
  <div class="cart-footer">
    <CartSummary
      :item-count="itemCount"
      :subtotal="subtotal"
      :tax-total="taxTotal"
      :vat-rate="vatRate"
      :currency="currency"
    />

    <div class="payable-card">
      <div>
        <span>{{ $t('retailSale.cart.totalPayable') }}</span>
        <small>{{ $t('retailSale.cart.netDueAtRegister') }}</small>
      </div>
      <strong>{{ formattedGrandTotal }}</strong>
    </div>

    <button
      type="button"
      class="payment-button"
      :disabled="pendingScanCount > 0"
      @click="$emit('complete-payment')"
    >
      <span>
        <i class="fas fa-money-bill-wave"></i>
        <b>{{ $t('retailSale.cart.completePayment') }}</b>
        <small v-if="pendingScanCount > 0">
          {{ $t('retailSale.search.scanningPending', { count: pendingScanCount }) }}
        </small>
        <small v-else>{{ $t('retailSale.cart.paymentMethods') }}</small>
      </span>
      <strong>{{ formattedGrandTotal }}</strong>
    </button>
  </div>
</template>

<script>
import CartSummary from './CartSummary.vue'
import { formatCurrency } from '../../utils/currency'

export default {
  name: 'CartFooter',
  components: {
    CartSummary
  },
  props: {
    itemCount: {
      type: Number,
      default: 0
    },
    subtotal: {
      type: Number,
      default: 0
    },
    taxTotal: {
      type: Number,
      default: 0
    },
    vatRate: {
      type: Number,
      default: 0
    },
    grandTotal: {
      type: Number,
      default: 0
    },
    currency: {
      type: Object,
      default: () => ({})
    },
    pendingScanCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    formattedGrandTotal() {
      return formatCurrency(this.grandTotal, this.currency)
    }
  }
}
</script>

<style scoped src="../../styles/cart-footer.css"></style>
